import { useCallback, useState } from 'react'

import { faSignature } from '@fortawesome/pro-regular-svg-icons'
import { Button } from 'antd'
import { HStack, Link, Modal, T } from 'govwell-ui'
import styled from 'styled-components'

import { LoadingSpin } from 'src/components/shared/StyledComponents'
import { SIGNATURE_ASPECT_RATIO } from 'src/components/SignatureEditor/util'
import { TextSize } from 'src/components/Typography/Text'

import useDisclosure from '../../hooks/use-disclosure'

const SignatureContainerInline = styled.img`
  border: 1px solid ${({ theme }) => theme.colorBorder};
  border-radius: 8px;
  max-width: 40%;
  height: auto;
  display: block;
`

type Props = {
  size?: TextSize
  type: 'modal' | 'inline'
  url: string
}
export const RenderedSignature = (props: Props) => {
  const { type, url, size } = props
  const modalState = useDisclosure()

  if (!url) {
    return null
  }

  if (type === 'inline') {
    return <SignatureContainerInline src={url} />
  }

  return (
    <>
      <T.Body>
        <Link onClick={modalState.open} className={size === TextSize.Small ? 'text-xs' : 'text-sm'}>
          View signature
        </Link>
      </T.Body>
      {modalState.isOpen && <SignatureModal url={url} onClose={modalState.close} />}
    </>
  )
}

type SignatureModalProps = {
  onClose: () => void
  url: string
}
const SignatureModal = ({ onClose, url }: SignatureModalProps) => {
  const [hasLoaded, setHasLoaded] = useState(false)
  const handleImageLoad = useCallback(() => {
    setHasLoaded(true)
  }, [])
  return (
    <Modal onClose={onClose}>
      <Modal.Header icon={faSignature}>Signature</Modal.Header>
      <Modal.Content>
        <div
          className="relative border"
          style={{
            aspectRatio: SIGNATURE_ASPECT_RATIO,
          }}
        >
          {!hasLoaded && (
            <LoadingSpin className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] scale-75" />
          )}
          <img alt="signature" className="object-contain" src={url} onLoad={handleImageLoad} />
        </div>
      </Modal.Content>
      <Modal.Footer>
        <HStack justify="end">
          <Button onClick={onClose}>Ok</Button>
        </HStack>
      </Modal.Footer>
    </Modal>
  )
}
